<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers /></el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								Add / Edit Training Type
							</div>
				
							<div class="page_main">
								<div class="training-type-page">
									<el-form ref="form" :model="form" :rules="rules" label-position="top"
										class="training-form">
				
										<!-- Top Tip -->
										<div class="tip-box">
											Please enter a descriptive name for this training type.
										</div>
				
										<!-- Training Type Name -->
										<el-form-item label="Training Type Name" prop="title">
											<el-input v-model="form.title" placeholder="Please enter"
												maxlength="100" clearable />
										</el-form-item>
				
				
										<!-- Information Block 1 -->
										<div class="info-box">
											<div class="info-text">
												Specify whether users can select this type when completing their assigned training.
											</div>
											<ul>
												<li>
													A training type cannot be configured with both
													"Allow users to sign off training completion?" set to "Yes"
													and "Does this indicate the requirement has been met?" set to "No".
												</li>
											</ul>
										</div>
				
				
										<!-- Allow User Sign-off Training Completion -->
										<el-form-item label="Allow Users to Sign Off Training Completion?"
											prop="allow_sign">
				
											<el-select v-model="form.allow_sign"
												placeholder="Please select"
												style="width: 100%">
				
												<el-option label="Yes" :value="1" />
												<el-option label="No" :value="2" />
				
											</el-select>
										</el-form-item>
				
				
										<!-- Information Block 2 -->
										<div class="info-box">
											<div class="info-text">
												Specify whether selecting this training type indicates that the user has met the training requirement.
											</div>
				
											<ul>
												<li>
													"Yes" indicates that this type is used when completed training satisfies the training requirement
													(for example, the user completes classroom training or comprehension training).
												</li>
				
												<li>
													"No" indicates that this type is used when the training record should be closed,
													but the user should not be considered as having met the training requirement
													(for example, failed training verification or user leave).
												</li>
				
												<li>
													"N/A" indicates that this type is used when the training record should be closed,
													but it should not be considered when determining whether the user has met the training requirement
													(for example, no review required - previous training applies).
												</li>
											</ul>
										</div>
				
				
										<!-- Does This Indicate Requirement Has Been Met -->
										<el-form-item label="Does This Indicate the Requirement Has Been Met?"
											prop="is_meet">
				
											<el-select v-model="form.is_meet"
												placeholder="Please select"
												style="width: 100%">
				
												<el-option label="Yes" :value="1" />
												<el-option label="No" :value="2" />
												<el-option label="N/A" :value="3" />
				
											</el-select>
										</el-form-item>
				
				
										<!-- Buttons -->
										<div class="btn-group">
				
											<el-button type="primary" @click="handleSave">
												Save
											</el-button>
				
											<el-button type="primary" @click="handleCancel">
												Cancel
											</el-button>
				
										</div>
				
									</el-form>
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { trainLeixingAdd, trainLeixingEdit, trainLeixingDetail } from '@/api/trainManage/configTrain/trainType/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
export
default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			form: {
				title: "",
				allow_sign: "",
				is_meet: "",
			},
			rules: {
				title: [{
					required: true,
					message: "Please enter",
					trigger: "blur"
				},
				],
				allow_sign: [{
					required: true,
					message: "Please select",
					trigger: "change",
				},
				],
				is_meet: [{
					required: true,
					message: "Please select",
					trigger: "change",
				},
				],
			},
		};
	},
	created() {
		let that = this;
	},
	mounted() {
		let that = this;
		if(that.$route.query.oid) {
			//编辑
			trainLeixingDetail({ id: that.$route.query.oid }).then(res => {
				if(res.code == 200) {
					that.form.id = res.data.id;
					that.form.title = res.data.title;
					that.form.allow_sign = res.data.allow_sign;
					that.form.is_meet = res.data.is_meet;
				}
				that.isLoading = false;
			});
		}else {
			that.isLoading = false;
		}
	},
	watch: {
		//
	},
	methods: {
		handleSave() {
			let that = this;
			that.$refs.form.validate((valid) => {
				if (!valid) return;
				that.$toast.loading({ duration: 0, forbidClick: true });
				if(that.$route.query.oid) {
					// 编辑
					trainLeixingEdit(that.form).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success("Operation successful");
							setTimeout(() => {
								that.$router.back();
							}, 800);
						}
					});
				}else {
					// 添加
					trainLeixingAdd(that.form).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success("Operation successful");
							setTimeout(() => {
								that.$router.back();
							}, 800);
						}
					});
				}
			});
		},
		handleCancel() {
			let that = this;
			that.$router.back();
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
}
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}

.training-type-page {
  background: #f5f5f5;
  min-height: 100vh;
  padding: 14px;
  box-sizing: border-box;
}

.training-form {
  width: 100%;
}

.tip-box,
.info-box {
  background: #f5efe4;
  border-radius: 6px;
  padding: 14px 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 18px;
  box-sizing: border-box;
}

.tip-box {
  font-size: 15px;
}

.info-box .info-text {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 4px;
}

.info-box ul {
  margin: 6px 0 0 20px;
  padding: 0;
}

.info-box li {
  margin: 2px 0;
}

::v-deep .el-form-item__label {
  font-size: 16px;
  color: #222;
  font-weight: 600;
  padding-bottom: 8px;
}

::v-deep .el-input__inner,
::v-deep .el-select .el-input__inner {
  height: 42px;
  line-height: 42px;
  border-radius: 6px;
  font-size: 14px;
}

.btn-group {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.btn-group .el-button {
  min-width: 88px;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  padding: 0 24px;
}

::v-deep .btn span {
  text-decoration: underline;
}
</style>

